module.exports = __webpack_public_path__ + "static/media/candorPixel16.5068649a.png";